import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { autoBind } from "src/shared/decorators/autobind";
import { inject, injectable } from "tsyringe";
import { BenefitDiscount } from "src/containers/wellbeing/discounts/models/discount/discount";
import { DiscountEstablishment } from "src/containers/wellbeing/discounts/models/establishment/establishment";
import { BenefitDiscountsRepository } from "src/containers/wellbeing/discounts/repositories/discounts/discounts-repository";

@injectable()
class BenefitDiscountsService {
    constructor(
        @inject("BenefitDiscountsRepository")
        private repository: BenefitDiscountsRepository
    ) {}

    @autoBind
    getDiscounts(
        businessLine: string,
        userIdentity: string
    ): Observable<Array<BenefitDiscount>> {
        return this.repository.getDiscounts(businessLine, userIdentity).pipe(
            map((data) =>
                data.map((d) => BenefitDiscount.fromJson<BenefitDiscount>(d))
            ),
            map((data) =>
                data.filter(
                    (value, index, self) =>
                        index === self.findIndex((t) => t.id === value.id)
                )
            )
        );
    }

    @autoBind
    getEstablishments(
        discountId: number,
        userIdentity: string
    ): Observable<Array<DiscountEstablishment>> {
        return this.repository
            .getEstablishments(discountId, userIdentity)
            .pipe(
                map((data) =>
                    data.map((e) =>
                        DiscountEstablishment.fromJson<DiscountEstablishment>(e)
                    )
                )
            );
    }
}

export { BenefitDiscountsService };
